import React, { type FunctionComponent, type ReactNode } from 'react'
import { Dialog } from '../Dialog'
import { Button } from '@tomra/design-system-react/button'

type Props = {
  title: string
  description?: string
  onClose: () => void
  children?: ReactNode
}

export const ErrorDialog: FunctionComponent<Props> = ({ title, description, onClose, children }) => {
  return (
    <Dialog ariaLabel={title}>
      <div className="rounded-2xl bg-white shadow-md dark:bg-gray-900 p-9 flex flex-col">
        <div className="self-center">
          <span className="icon-[fluent--error-circle-24-regular] size-24 text-rose-500" />
        </div>

        <h1 className="text-xl mt-6 mb-4">{title}</h1>

        {description && <p>{description}</p>}
        {children}

        <Button className="mt-6 px-9 self-end" onClick={onClose}>
          Ok
        </Button>
      </div>
    </Dialog>
  )
}
